import { useCallback } from "react";
import { ROUTES } from "@nf/constants";
import { useReplacePage } from "./useReplacePage";

export const useReplaceToLogout = () => {
  const replaceToLogoutPage = useReplacePage();
  return useCallback(() => {
    replaceToLogoutPage(ROUTES.LOGOUT);
  }, [replaceToLogoutPage]);
};
